import React, { Fragment, Component } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Callout } from 'office-ui-fabric-react/lib/Callout';

import RoundDateDisplay from 'components/RoundDateDisplay';
import { localizable } from 'components/Localization';

const config = {
  started: { color: '#666666', icon: 'Stop' },
  opened: { color: '#107c10', icon: 'Play' },
  closed: { color: '#ffb900', icon: 'StatusCircleCheckmark' },
};

const RoundCallout = styled(Callout)`
  padding: 1em;
  @media screen and (max-width: 479px) {
    left: 0 !important;
    width: 100%;
  }
`;

function getRoundType({ type, enableFlexibleBidding }) {
  switch (type) {
    case 'incremental_auction':
      return enableFlexibleBidding ? 'incremental_auction' : 'open_bidding';

    default:
      return type;
  }
}

@localizable
@observer
class RoundInfo extends Component {
  labelElement;

  @observable calloutVisible = false;

  handleCalloutToggle = action(() => {
    this.calloutVisible = !this.calloutVisible;
  });

  render() {
    var { round, t } = this.props;

    if (round.status === 'notStarted') {
      return <div></div>;
    }

    var data = {
      ...round,

      status: round.status || '',

      type: getRoundType(round),
      isPreview: !!round.startsAt && moment(round.startsAt).isAfter(moment()),
      startDuration: !!round.startsAt
        ? moment.duration(moment(round.startsAt).diff(moment())).humanize(true)
        : '',
      isPast: moment(round.endsAt).isBefore(moment()),
      hasEnd: !!round.endsAt || !!round.durationInDays,
      endDuration:
        round.durationType === 'fixed'
          ? moment.duration(moment().diff(moment(round.endsAt))).humanize()
          : '',
      endText:
        round.durationType === 'fixed'
          ? moment(round.endsAt).format('ddd ll LT')
          : '',
    };

    return (
      <Fragment>
        <div
          className="label"
          style={{
            borderRadius: '1em',
            background: config[round.status].color,
            cursor: 'pointer',
          }}
          ref={(element) => (this.labelElement = element)}
          onClick={this.handleCalloutToggle}
        >
          <i
            className={`ms-Icon ms-Icon--${config[round.status].icon}`}
            aria-hidden="true"
          ></i>
          {t('label', data)}
        </div>
        <RoundCallout
          role={'alertdialog'}
          gapSpace={0}
          target={this.labelElement}
          onDismiss={this.handleCalloutToggle}
          setInitialFocus={true}
          hidden={!this.calloutVisible}
        >
          <div>
            <div
              className="ms-font-l ms-fontWeight-semibold"
              style={{ color: '#003da5' }}
            >
              {t(`roundtype::${round.type}`)} ({t('Round')} {round.number})
            </div>
            <div>
              {t('Status')}: {t(`roundstatus::${round.status}`)}
            </div>
            {round.startsAt && (
              <Fragment>
                {t('Starts')}:{' '}
                {round.startsAt.toFormatedDateString('ddd ll / HH:mm')}
                <br />
              </Fragment>
            )}
            {t('Ends')}:{' '}
            <RoundDateDisplay
              end={round.endsAt}
              duration={round.durationInDays}
              format={'ddd ll / LT'}
            />
            {(!!round.offerValidityUntil || !!round.offerValidityInDays) && (
              <Fragment>
                <br />
                {t('Offer validity')}:{' '}
                <RoundDateDisplay
                  end={round.offerValidityUntil}
                  duration={round.offerValidityInDays}
                  format={'ddd ll / LT'}
                />
              </Fragment>
            )}
          </div>
        </RoundCallout>
      </Fragment>
    );
  }
}

export default RoundInfo;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/RoundInfo.jsx